export var convertToRequirementSelectValues = function (data) {
    if (!data)
        return [];
    return data.map(function (el) { return ({
        label: "".concat(el.standartShortName, " (").concat(el.countryType, ")"),
        value: el.id || '',
    }); });
};
